import { OktaAuth } from "@okta/okta-auth-js";
import oktaConfig from "@/okta_config";

export const oktaAuth = new OktaAuth(oktaConfig);

export const haveToGetANewToken = 403;
export const unAuthorized = 401;
export const AWS_PREFIX_ACCESSTOKEN = "accessToken";
export const AWS_PREFIX_REFRESHTOKEN = "refreshToken";

export async function logout() {
  await oktaAuth.signOut({
    postLogoutRedirectUri: `${window.location.origin}/login`,
  });
}

export async function login() {
  await oktaAuth.signInWithRedirect({
    originalUri: `/`,
  });
}

export function getAccessToken() {
  return oktaAuth.getAccessToken();
}

export function getRefreshToken() {
  return oktaAuth.getRefreshToken();
}

export function isAuthenticated() {
  return oktaAuth.isAuthenticated();
}

export function navigationGuard(to: any, _from: any, next: any) {
  const accessToken = getAccessToken();
  if (
    to.name !== "Login" &&
    to.name !== "LoginCallback" &&
    accessToken === undefined
  )
    next({ name: "Login" });
  else next();
}
